// extracted by mini-css-extract-plugin
export var container = "about-module--container--ny5mb";
export var description = "about-module--description--61JOw";
export var imageContainer = "about-module--image-container--+mDER";